import { render } from "./OrderDetailsPage.vue?vue&type=template&id=2a7f0020&scoped=true&ts=true"
import script from "./OrderDetailsPage.vue?vue&type=script&lang=ts"
export * from "./OrderDetailsPage.vue?vue&type=script&lang=ts"

import "./OrderDetailsPage.vue?vue&type=style&index=0&id=2a7f0020&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7f0020"]])

export default __exports__